// extracted by mini-css-extract-plugin
export default {"label":"sidebar_label__IyCrK"};